const analyticsEventLabel = {
  COMMON: {
    FAVORITE_WORKOUT: 'Favorite Workout',
    REMOVE_FAVORITE_WORKOUT: 'Remove Favorite Workout',
  },
  WORKOUT_DETAILS: {
    ALL_ON_DEMAND_WORKOUTS: 'All On-Demand Workouts',
    PLAY: 'Play',
    VOLUME_CHANGE: 'Volume Change',
    FULL_SCREEN: 'Full screen',
    CHECK_IN: 'Check In',
    CHECK_IN_INSIDE_MODAL: 'Check-In Inside Modal',
    LOGIN_OR_SIGN_UP_TO_WORK_OUT: 'Login or Sign Up to work out',
    UPGRADE_TO_JOIN: 'Upgrade to Join',
    AUTOMATED_CHECK_IN: 'Automated Checkin',
    CHECKIN_BADGE: 'Check-In Badge',
    AUTOMATED_CHECK_IN_FAILED: 'Automated Check-In Failed',
    TRAINER_INFORMATION: 'Trainer Information',
  },
  WORKOUTS: {
    CLEAR: 'Clear',
    FILTERS: 'Filters',
    ON_DEMAND_FILTERS: 'On-Demand Filters',
    SHOW_WORKOUTS: 'Show Workouts',
    UNSELECT_ALL: 'Unselect All',
    HIDE_COMPLETED_WORKOUTS: 'Hide Completed Workouts',
  },
  TRAINER_BIO: {
    CONTACT_INFO: 'View Contact Info',
    LOGIN_OR_SIGN_UP: 'Log In or Sign Up to Message Trainer',
    SIGN_UP: 'Sign Up to Message Trainer Popover',
    LOGIN: 'Log In to Message Trainer Popover',
    CLOSE_POPOVER: 'Log In or Sign Up to Message Trainer Popover',
    VIRTUAL_WORKOUTS: 'Virtual Workouts',
    OUTDOOR_LOCATIONS: 'Outdoor Locations',
    VIRTUAL_WORKOUT_CARD: 'Virtual Workout Card',
    OUTDOOR_LOCATION_CARD: 'Outdoor Location Card',
  },
}

export default analyticsEventLabel
